import { Box, Stack, Typography } from "@mui/material"
import { CostFigure } from "./cost-figure"

export function VisitFrequencyLegendItem({ item, totalCost, currencySymbol }) {
    const percentage = totalCost > 0 ? (item.cost / totalCost) * 100 : 0

    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <Box sx={{ width: 12, height: 12, borderRadius: "50%", bgcolor: item.color, flexShrink: 0 }} />
            <Typography variant="body2" color="text.primary" sx={{ flex: 1, fontSize: 16 }}>
                {item.label}
            </Typography>
            <CostFigure value={item.cost} currencySymbol={currencySymbol} fontWeight={700} sx={{ fontSize: 16 }} />
            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 48, textAlign: "right" }}>
                {Math.round(percentage)}%
            </Typography>
        </Stack>
    )
}
